(function(){
var P=window.COLO_P;if(!P||!P.pid)return;
function $(s,r){return (r||document).querySelector(s)}
function money(c){return '$'+(c/100).toFixed(2)}
async function add(id,btn){
  btn.disabled=true;btn.textContent='Adding…';
  var drawer=$('cart-drawer'),body={id:id,quantity:1};
  try{
    if(drawer&&drawer.getSectionsToRender){body.sections=drawer.getSectionsToRender().map(function(s){return s.id});body.sections_url=location.pathname}
    var r=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)});var st=await r.json();
    if(st.sections&&drawer){drawer.renderContents(st);btn.disabled=false;btn.textContent='+ Add to cart'}else location.href='/cart';
  }catch(e){btn.disabled=false;btn.textContent='+ Add to cart'}
}
async function go(){
  if($('.colo-ymal'))return;
  var list=[];
  try{var j=await (await fetch('/recommendations/products.json?product_id='+P.pid+'&limit=12&intent=related')).json();list=(j.products||[]).filter(function(p){return p.available!==false})}catch(e){}
  if(list.length<2)return;
  var w=document.createElement('section');w.className='colo-ymal';
  var h=document.createElement('div');h.className='colo-ymal__head';
  var t=document.createElement('h2');t.textContent='You may also like';h.appendChild(t);
  var ar=document.createElement('div');ar.className='colo-ymal__arrows';
  var pv=document.createElement('button');pv.type='button';pv.setAttribute('aria-label','Previous');pv.textContent='‹';
  var nx=document.createElement('button');nx.type='button';nx.setAttribute('aria-label','Next');nx.textContent='›';
  ar.appendChild(pv);ar.appendChild(nx);h.appendChild(ar);w.appendChild(h);
  var tr=document.createElement('div');tr.className='colo-upsell__track';
  list.forEach(function(p){
    var c=document.createElement('div');c.className='colo-up';
    var ia=document.createElement('a');ia.className='colo-up__img';ia.href=p.url;
    if(p.featured_image){var im=document.createElement('img');im.src=p.featured_image.replace(/(\.[a-z]+)(\?|$)/i,'_400x400$1$2');im.loading='lazy';im.alt='';ia.appendChild(im)}
    var ta=document.createElement('a');ta.className='colo-up__t';ta.href=p.url;ta.textContent=p.title;
    var pr=document.createElement('div');pr.className='colo-up__p';pr.textContent=money(p.price);
    if(p.compare_at_price&&p.compare_at_price>=p.price*2){var s=document.createElement('s');s.textContent=money(p.compare_at_price);pr.appendChild(s)}
    var b;
    if(p.variants&&p.variants.length>1){b=document.createElement('a');b.href=p.url;b.textContent='Choose options'}
    else{b=document.createElement('button');b.type='button';b.textContent='+ Add to cart';b.addEventListener('click',function(){add(p.variants[0].id,b)})}
    b.className='colo-up__btn';
    c.appendChild(ia);c.appendChild(ta);c.appendChild(pr);c.appendChild(b);tr.appendChild(c);
  });
  w.appendChild(tr);
  pv.addEventListener('click',function(){tr.scrollBy({left:-tr.clientWidth*0.8})});
  nx.addEventListener('click',function(){tr.scrollBy({left:tr.clientWidth*0.8})});
  var rel=$('product-recommendations.related-products');var sec=rel&&rel.closest('.shopify-section');
  if(sec)sec.before(w);else{var m=$('main');if(m)m.appendChild(w)}
}
document.addEventListener('DOMContentLoaded',go);
})();
